import api from './api';

const opensearchService = {
    getHealth:   ()                    => api.get('/admin/opensearch/health'),
    listIndices: ()                    => api.get('/admin/opensearch/indices'),
    deleteIndex: (indexName)           => api.delete(`/admin/opensearch/indices/${encodeURIComponent(indexName)}`),
    searchDocs:  (indexName, params)   => api.get(`/admin/opensearch/indices/${encodeURIComponent(indexName)}/docs`, { params }),
    getAggs:     (indexName, field)    => api.get(`/admin/opensearch/indices/${encodeURIComponent(indexName)}/docs`, { params: { agg: field } }),
    // Create/replace a payment-token index from an S3 file: { bucket, key, indexName }.
    createPaymentTokenIndex: (data)    => api.post('/admin/opensearch/payment-token-index', data),
    // Async PGP-decrypt an S3 file with the keypair secret: { bucket, key, secretName } -> { jobId, outputKey }.
    startPaymentTokenDecrypt:    (data)  => api.post('/admin/opensearch/payment-token-decrypt', data),
    getPaymentTokenDecryptStatus:(jobId) => api.get('/admin/opensearch/payment-token-decrypt-status', { params: { jobId } }),

    // Audit trail — cross-product record of who changed what. Filters are term matches on indexed
    // keywords: partnerId, accountId (chain), hotelId, userId, userEmail, product, productId, entity,
    // entityId, action, changedField, from_date, to_date, q, size, from.
    // The Payment Porter history tab (next step) will call this with { product: 'PaymentPorter', productId }.
    searchAudit:    (params)  => api.get('/admin/opensearch/audit', { params }),
    getAuditFacets: ()        => api.get('/admin/opensearch/audit/facets'),
};

export default opensearchService;
